// PayPal requires integer amounts for these currencies, including HUF/TWD
// (whose default Intl formatting otherwise allows fractions).
export function currencyDigits(currency) {
  if (['HUF', 'JPY', 'TWD'].includes(currency)) return 0;
  return new Intl.NumberFormat('en', { style: 'currency', currency }).resolvedOptions().maximumFractionDigits;
}

export function convertUsd(amount, rate, currency) {
  if (!Number.isFinite(amount) || amount < 0 || !Number.isFinite(rate) || rate <= 0) {
    throw new Error('Invalid currency conversion');
  }
  const scale = 10 ** currencyDigits(currency);
  const scaled = amount * rate * scale;
  return Math.round(scaled + Number.EPSILON * Math.max(1, Math.abs(scaled))) / scale;
}

export function formatMoney(amount, currency) {
  if (!Number.isFinite(amount)) return '—';
  const digits = currencyDigits(currency);
  return new Intl.NumberFormat(undefined, {
    style: 'currency', currency, currencyDisplay: 'code',
    minimumFractionDigits: digits, maximumFractionDigits: digits,
  }).format(amount);
}

// Round the unit price first so catalog, cart lines and payment totals agree.
// Sum integer minor units to avoid floating-point total discrepancies.
export function cartTotals(cart, shippingUsd, rate, currency) {
  const scale = 10 ** currencyDigits(currency);
  const items = cart.map(item => {
    const unit = convertUsd(item.price, rate, currency);
    const lineMinor = Math.round(unit * scale) * item.quantity;
    return { ...item, unit, line: lineMinor / scale, lineMinor };
  });
  const subtotalMinor = items.reduce((sum, item) => sum + item.lineMinor, 0);
  const shippingMinor = Math.round(convertUsd(shippingUsd, rate, currency) * scale);
  const total = (subtotalMinor + shippingMinor) / scale;
  return {
    currency, items, subtotal: subtotalMinor / scale, shipping: shippingMinor / scale, total,
    value: total.toFixed(currencyDigits(currency)),
  };
}
